module.exports = __webpack_public_path__ + "img/loufeng_unselected.d75ccf7f.png";